/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type PricingType = 0 | 1;

export const PricingType = {

    NUMBER_0: 0 as PricingType,

    NUMBER_1: 1 as PricingType
};

